<template>
  <div id="global-search">
    <slot></slot>
  </div>
</template>


<script>
  export default {
    data(){
      return {
      }
    },
    computed: {
    }
  }
</script>